import JSONTree from './JSONTree';

export default JSONTree;
